export const CART_CLEAR_CONSTANTS = {
  CLEAR_ALL_MSG: {
    MSGTXT1: 'clearCartAwareText',
    MSGTXT2: 'clearCartActionText',
    MSGTXT3: 'clearCartCompleteText',
  },
  CLEAR_ALL: 'continue',
  CANCEL: 'cancel',
  TO_CHANGE_LANGUAGE: 'toChangeLanguage',
};
